<div class="sales-page">
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <section class="overview-hero">
    <div class="hero-copy">
      <span class="hero-kicker">Sales & Finance</span>

      <h1>Track <span>Revenue</span></h1>

      <p>
        Review revenue performance, orders, payment status, and sales activity
        from one finance command center.
      </p>

      <div class="salon-scope-pill">
        <span>Salon view</span>
        <strong>{{ salonContext.selectionLabel() }}</strong>
      </div>
    </div>

    <div class="hero-actions">
      <button
        type="button"
        class="overview-btn overview-btn--dark"
        (click)="downloadReport()"
      >
        Export CSV
      </button>
    </div>
  </section>

  <section class="kpi-grid">
    <article class="kpi-card kpi-card--primary">
      <div>
        <span>Total Revenue</span>
        <strong>{{ toMoney(cardsData?.total_revenue) }}</strong>
        <p>Total completed revenue for the selected salon view.</p>
      </div>
    </article>

    <article class="kpi-card">
      <div>
        <span>Total Orders</span>
        <strong>{{ stats?.totalOrders || orders.length || 0 }}</strong>
        <p>Orders currently available across the selected salons.</p>
      </div>
    </article>

    <article class="kpi-card">
      <div>
        <span>Paid Orders</span>
        <strong>{{ paidOrdersCount }}</strong>
        <p>Orders marked as paid in the selected salon view.</p>
      </div>
    </article>

    <article class="kpi-card">
      <div>
        <span>Average Order</span>
        <strong>{{ toMoney(averageOrderValue) }}</strong>
        <p>Average order value across the currently loaded orders.</p>
      </div>
    </article>
  </section>

  <section class="panel revenue-panel">
    <header class="panel-head">
      <div>
        <span class="panel-kicker">Revenue Performance</span>
        <h2>Revenue Trend</h2>
        <p>
          Compare revenue across yearly, quarterly, monthly, weekly, and daily
          views for the selected salons.
        </p>
      </div>

      <div class="panel-actions">
        <button
          type="button"
          class="overview-btn overview-btn--light"
          (click)="downloadReport()"
        >
          Export CSV
        </button>
      </div>
    </header>

    <div class="revenue-summary">
      <div>
        <span>Total</span>
        <strong>{{ toMoney(cardsData?.total_revenue) }}</strong>
      </div>

      <glo-option-switch
        class="hidden md:flex"
        [options]="timePeriods"
        [selected]="selectedPeriod"
        (changed)="onPeriodChange($event)"
      >
      </glo-option-switch>

      <select
        class="filter-select md:hidden"
        [(ngModel)]="selectedPeriod"
        (change)="onMobilePeriodChange($event)"
      >
        @for (period of timePeriods; track period.value) {
          <option [value]="period.value">
            {{ period.label }}
          </option>
        }
      </select>
    </div>

    <div class="chart-shell">
      <canvas #revenueChartCanvas></canvas>
    </div>
  </section>

  <section class="panel orders-panel">
    <header class="panel-head orders-panel__head">
      <div>
        <span class="panel-kicker">Orders</span>
        <h2>Order Activity</h2>
        <p>
          Review recent customer orders and filter by payment or appointment
          status within the selected salon view.
        </p>
      </div>

      <div class="orders-growth">
        <strong>{{ stats?.totalOrders || orders.length || 0 }}</strong>

        <span
          [class.is-up]="stats?.growthDirection === 'up'"
          [class.is-down]="stats?.growthDirection !== 'up'"
        >
          {{ stats?.growthPct || 0 }}% vs last 30 days
        </span>
      </div>
    </header>

    <div class="orders-toolbar">
      <div class="orders-toolbar__scroll">
        <glo-option-switch
          [options]="orderTypes"
          [selected]="selectedOrderType"
          (changed)="onOrdersPeriodChange($event)"
        >
        </glo-option-switch>
      </div>
    </div>

    <div class="grid-shell">
      <glo-grid [rowData]="filteredOrders" [colDefs]="colDefs"></glo-grid>
    </div>
  </section>
</div>
